import { rankingData } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-start gap-10 lg:gap-16">
          <div className="lg:w-[320px] flex-shrink-0">
            <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-3">人气排行</h2>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed">
              基于读者阅读量与讨论热度的实时漫画排行榜，发现大家都在追的热门漫画全集。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <span className="flex items-center gap-1.5 text-xs text-foreground-400">
                <i className="ri-refresh-line text-sm"></i>
                每小时更新
              </span>
              <span className="w-1 h-1 rounded-full bg-background-300"></span>
              <span className="flex items-center gap-1.5 text-xs text-primary-600 font-medium">
                <i className="ri-arrow-up-line text-sm"></i>
                上升中
              </span>
            </div>
          </div>

          <div className="flex-1 w-full">
            <div className="space-y-2">
              {rankingData.map((item) => (
                <div
                  key={item.rank}
                  className="flex items-center gap-3 md:gap-4 p-3 md:p-4 bg-background-100/60 hover:bg-background-100 rounded-lg transition-colors cursor-pointer group"
                >
                  <div className={`w-7 h-7 md:w-8 md:h-8 flex items-center justify-center rounded-md font-heading font-bold text-sm flex-shrink-0 ${
                    item.rank <= 3
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-200 text-foreground-500'
                  }`}>
                    {item.rank}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                      <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-950 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                        {item.title}
                      </h3>
                      <span className="px-1.5 py-0.5 text-[10px] font-medium bg-secondary-100 text-secondary-700 rounded whitespace-nowrap">{item.tag}</span>
                      <span className={`text-[11px] font-medium whitespace-nowrap ${
                        item.status === '连载中' ? 'text-primary-600' : 'text-foreground-500'
                      }`}>{item.status}</span>
                    </div>
                    <div className="flex items-center gap-3 mt-1">
                      <span className="text-xs text-foreground-400">{item.chapter}</span>
                    </div>
                  </div>
                  <div className="flex items-center gap-3 md:gap-4 flex-shrink-0">
                    <div className="hidden sm:flex items-center gap-1">
                      {item.trend === 'up' ? (
                        <i className="ri-arrow-up-line text-xs text-primary-500"></i>
                      ) : (
                        <i className="ri-subtract-line text-xs text-foreground-400"></i>
                      )}
                      <span className={`text-xs font-medium ${
                        item.trend === 'up' ? 'text-primary-600' : 'text-foreground-500'
                      }`}>{item.heat}</span>
                    </div>
                    <span className="flex items-center gap-1 text-xs text-foreground-400 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                      <span>阅读</span>
                      <i className="ri-arrow-right-s-line text-sm"></i>
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}